export default "__VITE_PUBLIC_ASSET__ece8aaca__"